import React from 'react';

import ModalContainer from '@components/modals/ModalContainer';

const ConfirmationModal = ({ closeModal, title = null, description, callback, footerType = 'NORMAL' }) => {
	return (
		<ModalContainer onCloseModal={closeModal} size="md" className="material-update-modal">
			<div className="popup-wrapper">
				<div className="common-popup projection-review-modal shadow-24dp">
					{title && (
						<div className="common-popup-header d-flex justify-content-between">
							<div className="popup-tilte">
								<h3 className="semibold-16 mb-0">{title}</h3>
							</div>
							<div className="close-btn">
								<img
									src={`${process.env.PUBLIC_URL}/icons/close.svg`}
									alt="close"
									onClick={closeModal}
								/>
							</div>
						</div>
					)}
					<div className="common-popup-body">
						<div className="text-center">
							<p className="regular-14 gray_dark_01 text-left">Are you sure {description}</p>
						</div>
					</div>

					<div className="modal-footer">
						{footerType !== 'CLOSE' && (
							<div className="footer-buttons text-right">
								<button className="button gray-outline size32" onClick={closeModal}>
									No
								</button>
								<button className="button size32 ml-2" onClick={callback}>
									Yes
								</button>
							</div>
						)}
						{footerType === 'CLOSE' && (
							<div className="footer-buttons text-right">
								<button className="button gray-outline size32" onClick={closeModal}>
									Cancel
								</button>
								<button className="button red size32 ml-2" onClick={callback}>
									Confirm
								</button>
							</div>
						)}
					</div>
				</div>
			</div>
		</ModalContainer>
	);
};

export default ConfirmationModal;
